import React from "react";
import { Lock } from "lucide-react";

const Box = ({ children, style, testid }) => (
  <span
    data-testid={testid}
    className="inline-flex items-center justify-center rounded-[4px] bg-white border border-neutral-200 shadow-sm"
    style={{ height: 24, minWidth: 38, padding: "0 6px", ...style }}
  >
    {children}
  </span>
);

// Recognizable payment-brand marks rendered with CSS (no third-party image assets).
export const CardBadges = ({ className = "" }) => (
  <div className={`flex items-center gap-2 flex-wrap ${className}`} data-testid="card-trust-badges">
    <Box testid="badge-visa">
      <span style={{ color: "#1A1F71", fontStyle: "italic", fontWeight: 800, fontSize: 12, letterSpacing: "0.02em" }}>VISA</span>
    </Box>

    <Box testid="badge-mastercard">
      <span className="relative inline-block" style={{ width: 28, height: 16 }}>
        <span className="absolute rounded-full" style={{ width: 16, height: 16, left: 0, background: "#EB001B" }} />
        <span className="absolute rounded-full" style={{ width: 16, height: 16, left: 11, background: "#F79E1B", mixBlendMode: "multiply" }} />
      </span>
    </Box>

    <Box testid="badge-amex" style={{ background: "#2E77BC", borderColor: "#2E77BC" }}>
      <span style={{ color: "#fff", fontWeight: 800, fontSize: 9, letterSpacing: "0.04em" }}>AMEX</span>
    </Box>

    <Box testid="badge-discover">
      <span className="inline-flex items-center" style={{ fontWeight: 800, fontSize: 9, letterSpacing: "0.02em", color: "#1A201A" }}>
        DISC<span className="rounded-full ml-[1px]" style={{ width: 7, height: 7, background: "#F76C1B", display: "inline-block" }} />VER
      </span>
    </Box>

    <span className="inline-flex items-center gap-1 text-[0.6rem] text-neutral-500 ml-0.5" data-testid="badge-secure">
      <Lock size={11} /> Secured by Stripe
    </span>
  </div>
);

export default CardBadges;
